"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageTitlesAndBlockUidsReferencingPage = exports.getPageTitlesReferencingBlockUid = exports.getBlockUidsReferencingPage = exports.getBlockUidByTextOnPage = exports.getPageUidByPageTitle = exports.getPageViewType = exports.getAllBlockUids = exports.getAllPageNames = exports.getEditTimeByBlockUid = exports.getCreateTimeByBlockUid = exports.getDisplayNameByEmail = exports.getSettingsByEmail = exports.getParentTextByBlockUidAndTag = exports.getParentTextByBlockUid = exports.getPageTitleByPageUid = exports.getPageTitleByBlockUid = exports.getTextByBlockUid = exports.getEditedUserEmailByBlockUid = exports.fixViewType = exports.getTreeByPageName = exports.getTreeByBlockUid = exports.getParentUidByBlockUid = exports.getOrderByBlockUid = exports.getPageTitleReferencesByPageTitle = exports.getLinkedPageReferences = void 0;
const normalizePageTitle = (title) => title.replace(/\\/, "\\\\").replace(/"/g, '\\"');
const getLinkedPageReferences = (t) => {
    const findParentBlock = (b) => b.title
        ? b
        : findParentBlock(window.roamAlphaAPI.q(`[:find (pull ?e [*]) :where [?e :block/children ${b.id}]]`)[0][0]);
    const parentBlocks = window.roamAlphaAPI
        .q(`[:find (pull ?parentPage [*]) :where [?parentPage :block/children ?referencingBlock] [?referencingBlock :block/refs ?referencedPage] [?referencedPage :node/title "${normalizePageTitle(t)}"]]`)
        .filter((block) => block.length);
    return parentBlocks.map((b) => findParentBlock(b[0]));
};
exports.getLinkedPageReferences = getLinkedPageReferences;
const getPageTitleReferencesByPageTitle = (title) => window.roamAlphaAPI
    .q(`[:find ?t :where [?b :node/title ?t] [?b :block/children ?c] [?c :block/refs ?r] [?r :node/title "${normalizePageTitle(title)}"]]`)
    .map((p) => p[0]);
exports.getPageTitleReferencesByPageTitle = getPageTitleReferencesByPageTitle;
const getOrderByBlockUid = (blockUid) => {
    var _a, _b;
    return (_b = (_a = window.roamAlphaAPI.q(`[:find ?o :where [?r :block/order ?o] [?r :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0];
};
exports.getOrderByBlockUid = getOrderByBlockUid;
const getParentUidByBlockUid = (blockUid) => {
    var _a, _b;
    return (_b = (_a = window.roamAlphaAPI.q(`[:find ?u :where [?p :block/uid ?u] [?p :block/children ?e] [?e :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0];
};
exports.getParentUidByBlockUid = getParentUidByBlockUid;
const getTreeByBlockId = (blockId) => {
    var _a;
    const block = window.roamAlphaAPI.pull("[:block/children, :block/string, :block/order, :block/uid, :block/heading, :block/open, :children/view-type, :block/props]", blockId);
    const children = block[":block/children"] || [];
    const props = block[":block/props"] || {};
    return {
        text: block[":block/string"] || "",
        order: block[":block/order"] || 0,
        uid: block[":block/uid"] || "",
        children: children
            .map((c) => getTreeByBlockId(c[":db/id"]))
            .sort((a, b) => a.order - b.order),
        heading: block[":block/heading"] || 0,
        open: block[":block/open"] || true,
        viewType: (_a = block[":children/view-type"]) === null || _a === void 0 ? void 0 : _a.substring(1),
        props: {
            imageResize: Object.fromEntries(Object.keys(props[":image-size"] || {}).map((p) => [
                p,
                {
                    height: props[":image-size"][p][":height"],
                    width: props[":image-size"][p][":width"],
                },
            ])),
            iframe: Object.fromEntries(Object.keys(props[":iframe"] || {}).map((p) => [
                p,
                {
                    height: props[":iframe"][p][":size"][":height"],
                    width: props[":iframe"][p][":size"][":width"],
                },
            ])),
        },
    };
};
const getTreeByBlockUid = (blockUid) => {
    var _a, _b;
    const blockId = (_b = (_a = window.roamAlphaAPI.q(`[:find ?e :where [?e :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0];
    return getTreeByBlockId(blockId);
};
exports.getTreeByBlockUid = getTreeByBlockUid;
const getTreeByPageName = (name) => {
    const result = window.roamAlphaAPI.q(`[:find (pull ?e [:block/children :children/view-type]) :where [?e :node/title "${normalizePageTitle(name)}"]]`);
    if (!result.length) {
        return [];
    }
    const block = result[0][0];
    const children = (block === null || block === void 0 ? void 0 : block.children) || [];
    const viewType = (block === null || block === void 0 ? void 0 : block["view-type"]) || "bullet";
    return children
        .map((c) => getTreeByBlockId(c.id))
        .sort((a, b) => a.order - b.order)
        .map((c) => exports.fixViewType({ c, v: viewType }));
};
exports.getTreeByPageName = getTreeByPageName;
const fixViewType = ({ c, v, }) => {
    if (!c.viewType) {
        c.viewType = v;
    }
    c.children.forEach((cc) => exports.fixViewType({ c: cc, v: c.viewType }));
    return c;
};
exports.fixViewType = fixViewType;
const getEditedUserEmailByBlockUid = (blockUid) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?e :where [?u :user/email ?e] [?b :edit/user ?u] [?b :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getEditedUserEmailByBlockUid = getEditedUserEmailByBlockUid;
const getTextByBlockUid = (uid) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?s :where [?e :block/string ?s] [?e :block/uid "${uid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getTextByBlockUid = getTextByBlockUid;
const getPageTitleByBlockUid = (blockUid) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?t :where [?p :node/title ?t] [?e :block/page ?p] [?e :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getPageTitleByBlockUid = getPageTitleByBlockUid;
const getPageTitleByPageUid = (blockUid) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?t :where [?p :node/title ?t] [?p :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getPageTitleByPageUid = getPageTitleByPageUid;
const getParentTextByBlockUid = (blockUid) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?s :where [?p :block/string ?s] [?p :block/children ?e] [?e :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getParentTextByBlockUid = getParentTextByBlockUid;
const getParentTextByBlockUidAndTag = ({ blockUid, tag, }) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?s :where [?p :block/string ?s] [?p :block/refs ?t] [?t :node/title "${tag}"] [?b :block/parents ?p] [?b :block/uid "${blockUid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getParentTextByBlockUidAndTag = getParentTextByBlockUidAndTag;
const getSettingsByEmail = (email) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?settings :where[?e :user/settings ?settings] [?e :user/email "${email}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || {};
};
exports.getSettingsByEmail = getSettingsByEmail;
const getDisplayNameByEmail = (email) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?name :where[?e :user/display-name ?name] [?e :user/email "${email}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getDisplayNameByEmail = getDisplayNameByEmail;
const getCreateTimeByBlockUid = (uid) => {
    var _a, _b;
    return (_b = (_a = window.roamAlphaAPI.q(`[:find ?t :where [?e :create/time ?t] [?e :block/uid "${uid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0];
};
exports.getCreateTimeByBlockUid = getCreateTimeByBlockUid;
const getEditTimeByBlockUid = (uid) => {
    var _a, _b;
    return (_b = (_a = window.roamAlphaAPI.q(`[:find ?t :where [?e :edit/time ?t] [?e :block/uid "${uid}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0];
};
exports.getEditTimeByBlockUid = getEditTimeByBlockUid;
const getAllPageNames = () => window.roamAlphaAPI
    .q("[:find ?s :where [?e :node/title ?s]]")
    .map((b) => b[0]);
exports.getAllPageNames = getAllPageNames;
const getAllBlockUids = () => window.roamAlphaAPI
    .q(`[:find ?u :where [?e :block/uid ?u] [?e :block/string]]`)
    .map((f) => f[0]);
exports.getAllBlockUids = getAllBlockUids;
const getPageViewType = (title) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?v :where [?e :children/view-type ?v] [?e :node/title "${normalizePageTitle(title)}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "bullet";
};
exports.getPageViewType = getPageViewType;
const getPageUidByPageTitle = (title) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?u :where [?e :block/uid ?u] [?e :node/title "${normalizePageTitle(title)}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getPageUidByPageTitle = getPageUidByPageTitle;
const getBlockUidByTextOnPage = ({ text, title, }) => {
    var _a, _b;
    return ((_b = (_a = window.roamAlphaAPI.q(`[:find ?u :where [?b :block/page ?p] [?b :block/uid ?u] [?b :block/string "${text}"] [?p :node/title "${title}"]]`)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b[0]) || "";
};
exports.getBlockUidByTextOnPage = getBlockUidByTextOnPage;
const getBlockUidsReferencingPage = (title) => window.roamAlphaAPI
    .q(`[:find ?u :where [?r :block/uid ?u] [?r :block/refs ?p] [?p :node/title "${normalizePageTitle(title)}"]]`)
    .map((s) => s[0]);
exports.getBlockUidsReferencingPage = getBlockUidsReferencingPage;
const getPageTitlesReferencingBlockUid = (uid) => window.roamAlphaAPI
    .q(`[:find ?t :where [?r :block/uid "${uid}"] [?b :block/refs ?r] [?b :block/page ?p] [?p :node/title ?t]]`)
    .map((s) => s[0]);
exports.getPageTitlesReferencingBlockUid = getPageTitlesReferencingBlockUid;
const getPageTitlesAndBlockUidsReferencingPage = (pageName) => window.roamAlphaAPI
    .q(`[:find ?rt ?r :where [?pr :node/title ?rt] [?r :block/page ?pr] [?r :block/refs ?p] [?p :node/title "${normalizePageTitle(pageName)}"]]`)
    .map(([title, uid]) => ({ title, uid }));
exports.getPageTitlesAndBlockUidsReferencingPage = getPageTitlesAndBlockUidsReferencingPage;
